<template>
  <el-popover
    placement="top-start"
    trigger="hover"
    content="*PCR testing for Tickborne panel is not available through Dry Blood Spot collections."
    popper-class="dbs-tickborne-popover"
  >
    <template v-slot:reference>
      <span class="material-icons-outlined info-icon">
        info
      </span>
    </template>
  </el-popover>
</template>

<style scoped>
.info-icon {
  font-size: 18px;
}
</style>